<template>
  <div class="ms-grid-actions">
    <button
      class="ms-grid-actions__button-toggle"
      @blur="onBlur"
      @click="toggleDropDown"
    >
      <i class="grid-icon-more-vertical"/>
    </button>
    <div
      ref="actionDropDown"
      :class="{open:isOpen, closed:!isOpen}"
      class="ms-grid-action__drop-down"
    >
      <button
        v-for="(action,$index) of actions"
        v-if="isShowing(action.show)"
        :key="$index"
        @click="onClick(action.onClick)"
      >
        <i
          v-if="action.icon"
          :class="action.icon"
        />
        {{ action.label }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MsGridActions',
  props: {
    actions: {
      type: Array,
      required: true
    },
    row: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    toggleDropDown () {
      this.isOpen = !this.isOpen
      if (this.isOpen) {
        this.renderInside()
      }
    },
    /**
     * Shows or hide the current action button
     * @property {function, boolean} fnc - function or value, return true to show and false to.... yes, hide...
     */
    isShowing (fnc) {
      if (typeof fnc === 'function') {
        return fnc(this.row)
      } else if (typeof fnc === 'boolean') {
        return fnc
      }
      return true
    },
    onBlur () {
      setTimeout(() => {
        this.isOpen = false
      }, 300)
    },
    /**
       * Executes the action function
       * injecting the row values
       * @param {function} fnc - The action function to be executed
       */
    onClick (fnc) {
      fnc(this.row)
    },
    renderInside () {
      this.$refs.actionDropDown.style.display = 'block'
      this.$refs.actionDropDown.style.left = null
      this.$refs.actionDropDown.style.top = null

      let bounds = this.$refs.actionDropDown.getBoundingClientRect()
      let boundsWidth = bounds.x + bounds.width
      let boundsHeight = bounds.y + bounds.height

      if (boundsWidth > document.body.offsetWidth) {
        this.$refs.actionDropDown.style.left = (document.body.offsetWidth - boundsWidth - 20 + this.$refs.actionDropDown.style.left) + 'px'
      }
      if (boundsHeight > document.body.offsetHeight) {
        this.$refs.actionDropDown.style.top = (document.body.offsetHeight - boundsHeight - 20 + this.$refs.actionDropDown.style.top) + 'px'
      }
      this.$refs.actionDropDown.style.display = null
    }
  }
}
</script>

<style
  lang="scss"
  scoped
>
  .ms-grid-actions {
    position: relative;
    text-align: right;
  }

  .ms-grid-actions__button-toggle {
    background-color: transparent;
    border: none;
    cursor: pointer;
    padding: 10px;
    &:focus {
      outline: none;
    }
  }

  .ms-grid-action__drop-down {
    position: absolute;
    background-color: #fff;
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
    border: 1px solid #e0e0e0;
    cursor: pointer;
    z-index: 10;
    border-radius: 2px;
    min-width: 120px;
    opacity: 0;
    transform: translateY(-20px);
    &.closed {
      display: none;
      animation: on-close .3s ease-in-out forwards;
    }
    &.open {
      animation: on-open .3s ease-in-out forwards;
      display: block;
      top: 20px !important;
      left: -85px !important;
    }
    button {
      padding: 10px 10px;
      display: block;
      min-width: 100%;
      text-align: left;
      background-color: transparent;
      border: none;
      cursor: pointer;
      border-bottom: 1px solid #ededed;
      color: #444;
      transition: .3s all ease-in-out;
      &:hover {
        background-color: #f9f9f9;
      }
      i {
        padding: 5px;
        margin-right: 5px;
        color: #999999;
      }
      &:last-child {
        border-bottom: none;
      }
    }
  }

  @keyframes on-close {
    to {
      opacity: 0;
      transform: translateY(-20px);
    }
  }

  @keyframes on-open {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  } .ms-grid-actions {
      position: relative;
      text-align: right;
    }

  .ms-grid-actions__button-toggle {
    background-color: transparent;
    border: none;
    cursor: pointer;
    padding: 10px;
    &:focus {
      outline: none;
    }
  }

  .ms-grid-action__drop-down {
    position: absolute;
    background-color: #fff;
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
    border: 1px solid #e0e0e0;
    cursor: pointer;
    z-index: 10;
    border-radius: 2px;
    min-width: 120px;
    opacity: 0;
    transform: translateY(-20px);
    &.closed {
      display: none;
      animation: on-close .3s ease-in-out forwards;
    }
    &.open {
      animation: on-open .3s ease-in-out forwards;
      display: block;
    }
    button {
      padding: 10px 10px;
      display: block;
      min-width: 100%;
      text-align: left;
      background-color: transparent;
      border: none;
      cursor: pointer;
      border-bottom: 1px solid #ededed;
      color: #444;
      transition: .3s all ease-in-out;
      &:hover {
        background-color: #f9f9f9;
      }
      i {
        padding: 5px;
        margin-right: 5px;
        color: #999999;
      }
      &:last-child {
        border-bottom: none;
      }
    }
  }

  @keyframes on-close {
    to {
      opacity: 0;
      transform: translateY(-20px);
    }
  }

  @keyframes on-open {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

</style>



// WEBPACK FOOTER //
// src/modules/grid/ms-grid-actions.vue